import { lazy } from "react";
import { STUENT_JOURNEY_URL } from "../constants";

import FavouriteTeachers from "../pages/student/favourite-teachers/page.jsx";
import StudentDashboard from "../pages/student/student-stats/page.js";
import StudentNotifications from "../pages/student/notifications/index.jsx";

// Lazy loaded components
const StudentMessages = lazy(() => import("../pages/student/student-messages"));
const StudentOffers = lazy(() => import("../pages/student/student-offers"));
const StudentSession = lazy(() => import("../pages/student/StudentSession"));
const StudentMeetings = lazy(() => import("../pages/student/student-meetings"));
const StudentProfileSetting = lazy(() =>
  import("../pages/student/StudentProfile")
);
const WalletSummary = lazy(() => import("../pages/wallet"));
const SessionReviews = lazy(() => import("../pages/student/session-reviews"));
const UserSuccessCheckoutPage = lazy(() =>
  import("../pages/user-success-checkout-page")
);
const PaymentSuccessPage = lazy(() => import("../pages/payment-success"));

export const studentRoutes = [
  {
    path: `${STUENT_JOURNEY_URL}`,
    component: StudentMeetings,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/offers`,
    component: StudentOffers,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/messages`,
    component: StudentMessages,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/session/:id`,
    component: StudentSession,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/settings`,
    component: StudentProfileSetting,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/checkout-success`,
    component: UserSuccessCheckoutPage,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/wallet-summary`,
    component: WalletSummary,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/session-reviews`,
    component: SessionReviews,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/wallet-summary/payment-status`,
    component: PaymentSuccessPage,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/favourite-teachers`,
    component: FavouriteTeachers,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/dashboard`,
    component: StudentDashboard,
    protected: "",
  },
  {
    path: `${STUENT_JOURNEY_URL}/notifications`,
    component: StudentNotifications,
    protected: "",
  },
];
